import { AvatarComponent } from './../common/ag-component/avatar/avatar.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { CurrencyFormatPipe } from '../common/pipe/currency-format.pipe';
import {MenuModule} from 'primeng/menu';
import { ButtonAgGridComponent } from '../common/ag-component/button-renderermutibuttons.component';
import {ButtonModule} from 'primeng/button';
import { AvatarFullComponent } from '../common/ag-component/avatarFull.component';
import { ButtonRendererComponent } from '../common/ag-component/button-renderer.component';
import { IconButtonComponent } from './components/icon-button/icon-button.component';
@NgModule({
    exports: [
        CurrencyFormatPipe,
        ButtonAgGridComponent,
        AvatarFullComponent,
        ButtonRendererComponent,
        AvatarComponent,
        IconButtonComponent
    ],
    imports: [
        RouterModule,
        CommonModule,
        MenuModule,
        ButtonModule

    ],
    declarations: [
        CurrencyFormatPipe,
        ButtonAgGridComponent,
        AvatarFullComponent,
        ButtonRendererComponent,
        AvatarComponent,
        IconButtonComponent
    ],
    entryComponents: [

    ]
})
export class SharedCommonModule { }
